import { WritableSignal } from '@angular/core';

export class ArraySignalUtils {
  static removeAt<T>(array: WritableSignal<T[]>, index: number) {
    array.update(elements => elements.filter((_, i) => i !== index));
  }

  static pushBack<T>(array: WritableSignal<T[]>, newElement: T): void {
    array.update(elements => [...elements, newElement]);
  }
}
